import { useCallback } from "react";

import { useIntl } from "react-intl";

export const useTransformToRightNumber = () => {
  const { formatNumber } = useIntl();
  const transformToRightNumber = useCallback(
    (value = "0", decimals = 2) => {
      return formatNumber(isNaN(Number(value)) ? 0 : Number(value), {
        maximumFractionDigits: decimals,
        minimumFractionDigits: 2,
      });
    },
    [formatNumber],
  );

  return { transformToRightNumber };
};
